var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 518,
    height: 598,
    viewBox: "0 0 518 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218 251H368C450.843 251 518 318.157 518 401V491H368C285.157 491 218 423.843 218 341V251Z",
    fill: "#38ADAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190 251H100C44.7715 251 0 295.772 0 351V441H90C145.228 441 190 396.228 190 341V251Z",
    fill: "#9FC1C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M408 45H318C262.772 45 218 89.7715 218 145V235H308C363.228 235 408 190.228 408 135V45Z",
    fill: "#F18CAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M408 45L218 235V145C218 89.7715 262.772 45 318 45H408Z",
    fill: "#F07197"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 441L190 251L190 341C190 396.228 145.228 441 90 441H0Z",
    fill: "#86B3B3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218 251H368C450.843 251 518 318.157 518 401V491L218 251Z",
    fill: "#219E9F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72 457H190V521C190 553.585 163.585 580 131 580C98.4152 580 72 553.585 72 521V457Z",
    fill: "#F18CAA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 478.5H170.5V539C170.5 569.652 145.652 594.5 115 594.5C84.3482 594.5 59.5 569.652 59.5 539V478.5Z",
    stroke: "#DE5C82",
    strokeWidth: 7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40 185H190V75C190 33.5786 156.421 0 115 0C73.5786 0 40 33.5786 40 75V185Z",
    fill: "#CAEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 209.5H170.5V103C170.5 63.5116 138.488 31.5 99 31.5C59.5116 31.5 27.5 63.5116 27.5 103V209.5Z",
    stroke: "white",
    strokeWidth: 7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroDesign);
export default __webpack_public_path__ + "static/media/hero-design.b0a6a9217ee7a39295d96b612abc3f8e.svg";
export { ForwardRef as ReactComponent };